<template>
  <v-card class="uuid-generator tools-view-card">
    <ToolbarHeader :name="'UUID Generator'"/>
    <v-container>
      <section class="ma-5">
        <v-form
        >
          <v-row justify="center">
            <v-col cols="12"
                   sm="12"
                   md="8">
              <v-text-field
                  required
                  v-model="uuid"
                  name="UUID"
                  id="uuid-generator_value"
                  :label="`Your unique UUID`"
              />
            </v-col>
            <v-col cols="12"
                   sm="12"
                   md="2">
              <v-btn
                  color="primary"
                  class="mt-1 w-100"
                  @click="generateUUID"
              >
                Generate
              </v-btn>
            </v-col>
            <v-col cols="12"
                   sm="12"
                   md="2">
              <v-btn
                  color="primary"
                  class="mt-1 w-100"
                  @click="copy('uuid-generator_value')"
              >
                <v-icon dark>
                  mdi-content-copy
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-checkbox
              class="mt-0"
              @change="changeDashesStatus"
              v-model="dashesStatus"
              :label="`Dashes`"
          />
        </v-form>
      </section>
    </v-container>
  </v-card>
</template>

<script>
import ToolbarHeader from "@/components/Toolbar-Header";
import {copyMixin} from "@/mixins/copyMixin";

export default {
  name: "UUID-Generator",
  mixins: [copyMixin],
  components: {ToolbarHeader},
  data: () => ({
    uuid: '',
    uuidWithDashes: '',
    dashesStatus: true,
  }),
  created() {
    this.generateUUID();
  },
  methods: {
    generateUUID() {
      const basicUUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
      const uuid = basicUUID.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });

      this.dashesStatus = true;

      if (uuid) {
        this.setUUID(uuid);
      }
    },
    setUUID(uuid) {
      this.uuid = uuid;
      this.uuidWithDashes = uuid;
    },
    changeDashesStatus() {
      if (this.dashesStatus) {
        return this.uuid = this.uuidWithDashes;
      }

      if (!this.dashesStatus) {
        this.removeDashes();
      }
    },
    removeDashes() {
      this.uuid = this.uuid.replace(/-/g, "");
    }
  }
}
</script>
